import type { NextPage } from 'next';
import { PrivacyPolicy } from '../components/PrivacyPolicy/PrivacyPolicy';
import { Seo } from '../components/Seo/Seo';

const PrivacyPolicyPage: NextPage = () => {
  return (
    <>
      <Seo title="PRIVACY POLICY" />
      <PrivacyPolicy />
    </>
  );
};

export default PrivacyPolicyPage;
